import PocketBase from 'pocketbase'

/**
 * In production PocketBase serves this SPA from its own `pb_public`, so the API
 * is always same-origin — no base URL to configure, no CORS, no environment
 * variable that can be wrong in one place and right in another.
 *
 * In development Vite proxies `/api` and `/_` to 127.0.0.1:8090 (see
 * vite.config.ts), so the exact same relative URLs work there too.
 */
export const pb = new PocketBase(window.location.origin)

// The club's own CMS runs long editing sessions; auto-cancellation would abort
// an in-flight save the moment a list query re-runs beside it.
pb.autoCancellation(false)

/** Build a URL for a file field, optionally at one of the generated thumb sizes. */
export function fileUrl(
  record: { id: string; collectionId: string; collectionName?: string } | null | undefined,
  filename: string | undefined | null,
  thumb?: '100x100' | '400x400' | '800x0' | '1600x0' | '200x200'
): string | undefined {
  if (!record || !filename) return undefined
  return pb.files.getURL(record, filename, thumb ? { thumb } : undefined)
}

/**
 * PocketBase throws structured errors; this pulls out the one sentence worth
 * showing a human, preferring the first per-field validation message.
 */
export function errorMessage(error: unknown, fallback = 'Something went wrong.'): string {
  if (!error || typeof error !== 'object') return fallback

  const response = (error as { response?: { data?: Record<string, { message?: string }> } })
    .response
  const fields = response?.data
  if (fields) {
    for (const key of Object.keys(fields)) {
      const message = fields[key]?.message
      if (message) return `${key}: ${message}`
    }
  }

  const message = (error as { message?: string }).message
  return message && message !== 'Something went wrong while processing your request.'
    ? message
    : fallback
}
